import React from 'react';

import addHighlightBold700 from '@src/utils/addHighlightBold700';
import addHighlightBold from '@src/utils/addHighlightBold';
import addHighlight from '@src/utils/addHighlight';

import { HeaderMappingTypes, SectionHeaderPropTypes } from './SectionHeader.types';
import InspectorWrapper from '../InspectorWrapper';

const SectionHeader: React.FC<SectionHeaderPropTypes> = ({
  entryId = '',
  pretitle,
  id,
  title,
  className = '',
  preTitleClassName = '',
  childrenClassName = '',
  align,
  children,
  pretitleRef,
  titleRef,
  slideTextRef,
  paragraphRef,
  titleHighlightBold,
  titleClassName = '',
  headingLevel = 'h2',
}) => {
  const HeadingTag = HeaderMappingTypes[headingLevel];

  // Function to get alignment classes
  const getAlignmentClasses = (alignment?: string) => {
    switch (alignment) {
      case 'center':
        // return 'items-center justify-center text-center';
        return 'items-start justify-center text-left md:items-center md:justify-center md:text-center';
      case 'left':
        return '';
      // Add more cases here if needed
      default:
        return '';
    }
  };

  if (slideTextRef) {
    titleRef = slideTextRef;
  }

  return (
    <header id={id} className={`flex flex-col ${className} ${getAlignmentClasses(align)}`}>
      {pretitle && (
        <InspectorWrapper entryId={entryId} fieldId='preTitle'>
          <p
            ref={pretitleRef}
            className={`text-primary mb-[1.6rem] text-[1.4rem] leading-[2.4rem] font-normal tracking-[0.4px] uppercase ${preTitleClassName}`}
            style={{ textShadow: 'rgb(143, 66, 0, 0.2) 1px 0px 0px, rgb(143, 66, 0, 0.2) 0.540302px 0.841471px 0px' }}
            dangerouslySetInnerHTML={{
              __html: addHighlightBold700(pretitle),
            }}
          />
        </InspectorWrapper>
      )}

      {title && (
        <InspectorWrapper entryId={entryId} fieldId='title'>
          <HeadingTag
            ref={titleRef}
            className={`text-[2.4rem] leading-[3.2rem] text-pretty ${titleClassName}`}
            dangerouslySetInnerHTML={{
              __html: titleHighlightBold ? addHighlightBold(title) : addHighlight(title),
            }}
          />
        </InspectorWrapper>
      )}

      {children && (
        <div
          ref={paragraphRef}
          className={`max-w-none text-[1.6rem] text-pretty xl:max-w-[73.7rem] ${childrenClassName}`}
        >
          {children}
        </div>
      )}
    </header>
  );
};

export default SectionHeader;
